import { withHook } from 'utils/withHook';
import { useNewsPreviewState } from 'containers/NewsPreview/logic/useNewsPreviewState';
import { NewsPreviewView } from 'containers/NewsPreview/view/NewsPreview';

export const NewsPreview = withHook(useNewsPreviewState)(NewsPreviewView);
